/**
 * Type of modal.
 */
export const TYPE = {
  CLIENT: 0,
  DEVICE: 1,
  USER: 2,
  ENVIRONMENT: 3
};

/**
 * Type of actions.
 */
export const ACTION = {
  ADD: 0,
  UPDATE: 1,
  UPDATE_MANY: 2,
  IMPORT: 3,
  RELEASE: 4
};

/**
 * Action for open the save modal.
 */
export function openSave(data = {}, type) {
  return {
    type: 'SAVE_UPDATE_MODAL_OPEN',
    payload: {
      type,
      action: ACTION.ADD,
      data
    }
  };
}

/**
 * Action for open the update modal.
 * @param {Integer} type Modal type () to be updated.
 * @param {Object} data Data to be passed to the backend.
 * @param {Function} onSuccessCallback Function to be called when the popup has a success.
 */
export function openUpdate(data, onSuccessCallback) {
  return {
    type: 'SAVE_UPDATE_MODAL_OPEN',
    payload: {
      action: ACTION.UPDATE,
      data,
      onSuccessCallback
    }
  };
}

/**
 * Action for open the import modal.
 */
export function openImport(data = {}, type) {
  return {
    type: 'SAVE_UPDATE_MODAL_OPEN',
    payload: {
      type,
      action: ACTION.IMPORT,
      data
    }
  };
}

export function openVisitationTypeUpdate(data, onSuccessCallback) {
  return {
    type: 'SAVE_UPDATE_MODAL_OPEN',
    payload: {
      action: ACTION.UPDATE_MANY,
      data,
      onSuccessCallback
    }
  };
}

/**
 * Close the save or update modal.
 */
export function closeSaveUpdate() {
  return {
    type: 'SAVE_UPDATE_MODAL_CLOSE'
  };
}

// export function closeSaveRelease() {
//   return {
//     type: 'SAVE_UPDATE_MODAL_RELEASE_CLOSE'
//   };
// }
